import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Form, InputPicker, Toggle } from 'rsuite';
import { getStates, getSurveyingExamDiscipline } from '../../../../services/Shared/codeTable.service';
import YesNoRadioOption from '../../../Shared/RadioButton/YesNoRadioOption';

function PlsLsiAdditionalInformationSection() {
    const [states, setStates] = useState([])
    const [examDiscipline, setExamDiscipline] = useState([])
    const stateSearch = (userInput, label, dataItem) => {
        if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput)
            return true;
    }
    useEffect(() => {
        getStates().then(setStates);
        getSurveyingExamDiscipline().then(setExamDiscipline);
    }, [])

    return <>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Comity State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="comityState" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>LSI Cert. Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="lsiCertDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>LSI Cert #</b></Form.ControlLabel>
                    <Form.Control name="lsiCertNumber" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>FS Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="fsExamDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>FS Exam State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="fsExamState" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PLS Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="plsExamDate" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PLS Exam State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="plsExamState" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PLS Lic Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="plsLicenseDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PLS Lic State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="plsLicenseState" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">

            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PLS Lic #</b></Form.ControlLabel>
                    <Form.Control name="plsLicenseNumber" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Surveying Exam Discipline</b></Form.ControlLabel>
                    <Form.Control
                        data={examDiscipline}
                        accepter={InputPicker}
                        searchable={true}
                        block
                        name="plsExamDiscipline" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Oral Interview Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="oralExamDate" />
                </Form.Group>
            </Col>

        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>LA Laws Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="laLawsExamDate" />
                </Form.Group>
            </Col>
            <Col>
            </Col>
            <Col>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Model Law</b></Form.ControlLabel>
                    <YesNoRadioOption radioName="isModelLaw" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Act 2</b></Form.ControlLabel>
                    <YesNoRadioOption radioName="isAct2" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PLS by Endorsement</b></Form.ControlLabel>
                    <YesNoRadioOption radioName="isByEndorsement" />
                </Form.Group>
            </Col>
        </Row>

    </>;
}
export default PlsLsiAdditionalInformationSection;